<template>
  <div class="container" @mousedown="click" v-bind:title="title">
    <div class="icon"><i class="fa fa-map-marker"></i></div>
    <div class="text">
      <p class="headline" v-html="headline"></p>
      <p class="subline" v-html="subline"></p>
    </div>
    <div class="arrow"><i class="fa fa-chevron-right"></i></div>
  </div>
</template>

<script>
import SearchObject from "../../SearchObject";

export default {
  name: "NeedleItemLocation",
  data() {
    return {
      searchObj: new SearchObject(),
    };
  },
  computed: {
    title() {
      return this.$attrs.item.Title || '';
    },
    headline() {
      return this.boldIt(this.$attrs.item.Title, this.$attrs.needle);
    },
    subline() {
      let loc = this.$attrs.item.Location[0],
          str = [loc.City, loc.SubRegion, loc.Region, loc.Country]
              .filter(function (el) {
                return el != '';
              })
              .join(', ');
      return this.boldIt(str, this.$attrs.needle);
    }
  },
  methods: {
    click() {
      let loc = this.$attrs.item.Location[0];
      let locString = [loc.Country, loc.Region, loc.SubRegion, loc.City]
          .filter(function (el) {
            return el != '';
          })
          .join(',');
      this.searchObj.combinedRegion = locString;
      this.searchObj.setLocation(locString);
      this.searchObj.Needle = this.$attrs.item.Title;
      self = this;
      this.$parent.$parent.$parent.$parent.$data.showOverlay = true;
      setTimeout(() => self.$parent.$parent.$refs.form.submit(), 300);
    }
  }
};
</script>

<style lang="scss">
</style>